import { render, staticRenderFns } from "./shigong.vue?vue&type=template&id=b0862588"
import script from "./shigong.vue?vue&type=script&lang=js"
export * from "./shigong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports